<script setup lang="ts">
import { computed } from 'vue'

import { HospitalizationTypeFullName, HospitalizationTypeIcon, HospitalizationTypeLabel } from '@/misc/constants'
import { HospitalizationType } from '@/store/modules/stay/smr/types'

const props = defineProps<{
  type: HospitalizationType
}>()
const displayedIcon = computed(() => HospitalizationTypeIcon[props.type])
const displayedLabel = computed(() => HospitalizationTypeLabel[props.type])
const displayedFullName = computed(() => `Hospitalisation ${HospitalizationTypeFullName[props.type]}`)

</script>

<template>
  <span
    v-tooltip="displayedFullName"
    class="badge hosptype-badge text-black"
  >
    <span
      v-if="displayedIcon"
      class="hosptype-badge__icon"
    >
      {{ displayedIcon }}
    </span>
    {{ displayedLabel }}
  </span>
</template>

<style scoped lang="scss">
.hosptype-badge {
  font-size: 45%;
  background-color: rgba(0, 0, 0, .05);
  display: inline-flex;
  align-items: center;
  column-gap: 3px;

  &__icon {
    font-size: 1.45em;
    font-family: 'Tahoma', serif;
    margin-bottom: 3px;
  }
}
</style>
